import { isAfter, isBefore, isEqual, isMonday, isTuesday, isWednesday, isThursday, isFriday, isSunda, isSunday } from 'date-fns';
import datepicker from 'js-datepicker';

const ACTIVE_CLASS = 'active';
const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

interface OffDays {
  open: Date,
  close: Date,
}

function calculateOffDays(date: Date, closing_times: OffDays[], closed_days: NodeListOf<HTMLElement> | undefined) {
  const closedDays : string[] = [];

  if (isSunday(date)) {
    return true;
  }

  if (closed_days !== undefined && closed_days.length > 0) {
    [...closed_days].forEach((el : HTMLElement) => {
      const day = el.dataset.day;
      if (day !== undefined) {
        closedDays.push(day);
      }
    });
  }

  if (closing_times.some(({open,close}) =>  isBefore(date, close) && isAfter(date, open))) {
    return true;
  } else if (closedDays.includes('monday') && isMonday(date)) {
    return true;
  } else if (closedDays.includes('tuesday') && isTuesday(date)) {
    return true;
  } else if (closedDays.includes('wednesday') && isWednesday(date)) {
    return true;
  } else if (closedDays.includes('thursday') && isThursday(date)) {
    return true;
  } else if (closedDays.includes('friday') && isFriday(date)) {
    return true;
  }
}


const init = (wrapper: HTMLElement) => {
  const hidden_data = document.querySelectorAll('.date-picker__hidden-data') as NodeListOf<HTMLElement>;
  const closed_days = document.querySelectorAll('.date-picker__hidden-day') as NodeListOf<HTMLElement>;
  const closing_times : OffDays[] = [];
  const calendar_offset_element = document.querySelector('.date-picker__hidden') as HTMLElement;
  const calendarOffset = new Date(calendar_offset_element.dataset.offset ?? '+1 week');
  const daySelect : HTMLElement = document.querySelector('.flow-day');
  const dayLabel : HTMLElement = document.querySelector('.flow-day__day-label');
  const dayChecks = document.querySelectorAll('.flow-day__checkbox') as NodeListOf<HTMLInputElement>;

  if (hidden_data !== undefined && hidden_data.length > 0) {
    [...hidden_data].forEach((data : HTMLElement) => {
      const open = new Date(data.dataset.open ?? '');
      const close = new Date(data.dataset.closed ?? '');
      closing_times.push({open, close})
    });
  }

  const calendar = datepicker('.date-picker__calendar', {
    alwaysShow: true,
    minDate: calendarOffset,
    disableYearOverlay: true,
    startDay: 1,
    customDays: [
      'Zo',
      'Ma',
      'Di',
      'Wo',
      'Do',
      'Vr',
      'Za',
    ],
    customMonths: [
      'Januari',
      'Februari',
      'Maart',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Augustus',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    disabler: (currentDate) => {
      return calculateOffDays(currentDate, closing_times, closed_days);
    },
    onSelect: (instance, date) => {
      if (date !== undefined) {
        daySelect.classList.add(ACTIVE_CLASS);
        const returnDate = date.toLocaleDateString("nl-NL", dateOptions);
        dayChecks.forEach((check) => {
          check.checked = false;
        });
        dayLabel.innerHTML = returnDate;
      } else {
        daySelect.classList.remove(ACTIVE_CLASS);
        dayChecks.forEach((check) => {
          check.checked = false;
        });
      }
    },
    formatter: (input, date, instance) => {
      input.value = date.toLocaleDateString("nl-NL", dateOptions);
    },
  });
}

export default init;
